import { StateStatus } from '../../enums/StateStatus';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';

export interface EntityState<T> {
  byId: Record<number, T>;
  status: StateStatus;
  error: RestErrorResponse | null;
}

export const defaultEntityState: EntityState<any> = {
  byId: {},
  status: StateStatus.Initial,
  error: null
};
